module.exports = __webpack_public_path__ + "img/homebg01.571a707d.svg";